module.exports = __webpack_public_path__ + "static/media/money-bill-1-solid.b80322f5.svg";